import InputConfig from '../../Components/InputConfig';
import { SPLIT_DOC_PARAMETERS } from '../../core/constants';

//mui imports====
import { Grid, Paper } from '@mui/material';
import SwitchInput from '../../Components/SwitchInput';
//===============

const { ENABLED, SITE_DOMAIN, SITE_ID } = SPLIT_DOC_PARAMETERS;

const GeneralSettings = ({ splitDoc, updateSplitDoc }) => {
	const updateParameter = (parameterName, parameterValue) => {
		const clonedSplitDoc = structuredClone(splitDoc);
		clonedSplitDoc[parameterName] = parameterValue;
		updateSplitDoc(clonedSplitDoc);
	};

	return (
		<Paper sx={{ padding: '6rem', margin: '3rem 6rem 3rem 3rem' }}>
			{splitDoc && (
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<SwitchInput
							label={ENABLED}
							isObjectEditor={false}
							directValue={splitDoc[ENABLED]}
							updateDirectValue={(val) => updateParameter(ENABLED, val)}
						/>
					</Grid>
					<Grid item xs={6}>
						<InputConfig
							label="Site Id"
							isObjectEditor={false}
							directValue={splitDoc[SITE_ID]}
							editable={false}
							updateDirectValue={(val) => updateParameter(SITE_ID, val)}
							inputType="number"
						/>
					</Grid>
					<Grid item xs={6}>
						<InputConfig
							label="Site Domain"
							isObjectEditor={false}
							directValue={splitDoc[SITE_DOMAIN]}
							editable={false}
							updateDirectValue={(val) => updateParameter(SITE_DOMAIN, val)}
						/>
					</Grid>
				</Grid>
			)}
		</Paper>
	);
};

export default GeneralSettings;
